<template>
    <div class="security-rules">
        <el-alert
            v-if="displayMessageError"
            :class="darkMode ? 'dark-alert' : ''"
            title=""
            type="error"
            style="margin-bottom: 18px;"
        >
            <span v-if="serverErrorMessage">{{ serverErrorMessage }}</span>
        </el-alert>
        <el-alert
            ref="passwordRuleError"
            :class="darkMode ? 'dark-alert' : ''"
            :closable="false"
            type="info"
        >
            <p>{{ currentLang === 'fr' ? 'Règles' : 'Rules' }}</p>
            <div
                v-loading="true"
                v-if="securityRules === null"
                element-loading-text="Searching for rules"
                element-loading-background="rgb(244,244,245)"
                class="loading-rules"
            ></div>
            <p v-else-if="securityRules === 'error'" class="rule-error text-center">
                Server error, rules can't be fetched
            </p>
            <template v-else>
                <ul v-if="securityRules.length">
                    <template v-for="(rule, index) in securityRules" >
                        <li :key="index" :class="rule.code === serverError ? 'rule-error rule-message' : ''">
                            {{ rule[`message_${currentLang}`] }}
                        </li>
                    </template>
                </ul>
                <p v-else class="text-center rule-message">No rules availables.</p>
            </template>
        </el-alert>
    </div>
</template>

<script>

import HttpErrorManager from '../partials/http-error-manager.js';
export default {

    components: {

    },

    props: {
        darkMode: {
            type: Boolean,
            default: false,
        },
        currentLang: {
            type: String,
            default: 'fr',
        },
        serverError: {
            type: String,
            default: '',
        },
        serverErrorMessage: {
            type: String,
            default: '',
        },
    },
    data (){
        return {
            securityRules: [],
        };
    },

    computed: {
        rulesCodes (){
            return this.securityRules.map(rule => rule.code);
        },
        displayMessageError (){
            return this.serverErrorMessage && !this.rulesCodes.includes(this.serverError);
        },
    },

    watch: {
        serverError (val){
            if(this.rulesCodes.includes(val)){
                this.$refs.passwordRuleError.$el.animate(
                    [
                        { transform: 'translateX(0px)'},
                        { transform: 'translateX(-10px)'},
                        { transform: 'translateX(10px)'},
                    ],
                    {
                        iterations: 2,
                        duration: 150,
                    }
                );
            }
        },
    },

    mounted (){
        this.$store.dispatch('listSecurityRyles').then((rules) => {
            this.$set(this, 'securityRules', rules || []);
        }).catch(() => {
            this.securityRules = 'error';
        });
    },

    methods: {

    },
};
</script>

<style lang="scss">
.security-rules{
    .rule-error{
        color: #F56C6C;
    }
    .rule-message{
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/rules-alert.vue